export default "__VITE_ASSET__k0SBVF41__"